import { App } from '../App';
import { useAuth } from '../lib/auth';
import { WorkspaceProvider } from '../lib/workspace';

// Discard all workspace buffers immediately when identity changes, including sign-out.
export function WorkspaceSession() {
  const { status, email } = useAuth();
  return <WorkspaceProvider key={`${status}:${email ?? ''}`}><App /></WorkspaceProvider>;
}
